module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "catalog-list-sort"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "list-item action"
    }, [_c('ExtLink', {
      staticClass: "link",
      class: {
        active: item.active
      },
      attrs: {
        "to": item.to
      }
    }, [_vm._v(_vm._s(item.text))])], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b641e06","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/catalog/list/sort/component.vue
// module id = 55ddbba244a46a1af2f8
// module chunks = 89